import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/counter-profiles',
    name: 'counter-profile',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/counter-profile/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('inventory/counterProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/counter-profiles/:id',
    name: 'counter-profile-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/counter-profile/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('inventory/counterProfile/dataBeforeCreate')
      await store.dispatch('inventory/counterProfile/find', to.params.id)
      next()
    }
  }
]
